<template>
  <div class="text-dark">
    <b-container fluid>
      <div v-if="detailSubscription && isMandiriVa && normalizedStatus">
        <b-row align-h="center">
          <b-col xl="5" lg="6" md="8" sm="9" xs="12">
            <!-- Title -->
            <b-row class="mb-1">
              <b-col class="size24 fw-bold-800">
                {{ normalizedStatus === 'pending' ? 'Detail Transaksi' : 'Detail Berlangganan' }}
              </b-col>
            </b-row>

            <!-- ID -->
            <b-row class="mb-2">
              <b-col>ID Transaksi</b-col>
              <b-col
                class="text-right"
                :class="{ 'cursor-pointer': normalizedStatus === 'success' }"
                @click="normalizedStatus === 'success' && print()"
              >
                <template v-if="normalizedStatus === 'success'">
                  <b-button class="bg-white border-8">
                    {{ detailSubscription.invoice_number }}
                  </b-button>
                </template>
                <template v-else>
                  {{ detailSubscription.invoice_number }}
                </template>
              </b-col>
            </b-row>

            <!-- Status -->
            <b-row class="mb-2">
              <b-col>Status</b-col>
              <b-col class="text-right">
                <span :class="['p-1','rounded-pill','fw-bold-700', statusBadgeClass]">
                  {{ statusLabel }}
                </span>
              </b-col>
            </b-row>

            <!-- Paket -->
            <b-row class="mb-2" v-if="detailSubscription.subscription_renewal">
              <b-col>Paket Berlangganan</b-col>
              <b-col class="text-right">
                {{ detailSubscription.subscription_renewal.renewal_name }}
              </b-col>
            </b-row>

            <!-- Nominal (pakai sell_price jika ada) -->
            <b-row class="mb-2" v-if="amountValue != null">
              <b-col>Total Kredit </b-col>
              <b-col class="text-right">
                {{ amountValue | formatInvoice }}
              </b-col>
            </b-row>

            <!-- Total / Total Tagihan -->
            <b-row class="mb-2">
              <b-col>Total Tagihan </b-col>
              <b-col class="text-right">
                {{ parseFloat(detailSubscription.total) | formatAmount }}
              </b-col>
            </b-row>

            <!-- Metode Pembayaran + VA -->
            <b-row class="mb-2">
              <b-col>Metode Pembayaran</b-col>
              <b-col class="text-right">
                MANDIRI VA - {{ detailSubscription.xendit_provider.va_account_number }}
                <feather-icon
                  icon="CopyIcon"
                  class="text-primary cursor-pointer"
                  size="16"
                  @click="copyToClipboard(detailSubscription.xendit_provider.va_account_number)"
                />
                <div v-if="copied" class="badge badge-light-success mt-50">
                  Berhasil disalin!
                </div>
              </b-col>
            </b-row>

            <!-- Waktu Transaksi -->
            <b-row class="mb-2" v-if="detailSubscription.created_at">
              <b-col>Waktu Transaksi</b-col>
              <b-col class="text-right">
                {{ detailSubscription.created_at }}
              </b-col>
            </b-row>

            <!-- Bayar Sebelum / Berlaku Hingga -->
            <b-row class="mb-5" v-if="expireValue">
              <b-col>{{ expireLabel }}</b-col>
              <b-col class="text-right" :class="{ 'text-danger': normalizedStatus === 'pending' }">
                {{ expireValue }}
              </b-col>
            </b-row>

            <!-- Cara Bayar (pending + bni_va) -->
            <template v-if="showCaraBayar">
              <b-row class="mb-1">
                <b-col class="size24 fw-bold-800">Cara Bayar</b-col>
              </b-row>

              <div class="card p-1" v-b-toggle.collapse-1 variant="primary">
                <div class="d-flex align-items-center">
                  <b-img :src="require('/src/assets/images/logo/mandiri.png')" alt="mandiri" style="width: 4rem" />
                  <span class="ml-1"> Bank Mandiri - Virtual Account </span>
                  <span class="ml-auto">
                    <feather-icon icon="ChevronDownIcon" size="16" />
                  </span>
                </div>
                <b-collapse id="collapse-1">
                  <hr />
                  <div class="size16 fw-bold-900 ml-1">Melalui ATM</div>
                  <ol>
                    <li>Silahkan pilih menu “Bayar/Beli”</li>
                    <li>
                      Selanjutnya akan muncul tipe pembayaran seperti Multi
                      Payment dan Bill Payment (PLN, PDAM, dll), untuk pembayaran
                      VA pilih “Multi Payment”
                    </li>
                    <li>
                      Silahkan masukkan kode perusahaan, contoh: “88908” (Xendit),
                      lalu pilih “Benar”
                    </li>
                    <li>
                      Masukkan nomor Virtual Account Anda (contoh:
                      8890802001287578) dan klik “Benar”
                    </li>
                    <li>
                      Isikan nominal yang akan dibayarkan, kemudian tekan “Benar”
                    </li>
                    <li>
                      Jangan lupa untuk memeriksa informasi yang tertera pada
                      layar. Pastikan semua informasi dan total tagihan yang
                      ditampilkan sudah benar. Jika benar, tekan angka 1 dan pilih
                      “Ya”
                    </li>
                    <li>
                      Periksa layar konfirmasi dan pilih “Ya” untuk melakukan
                      pembayaran
                    </li>
                    <li>
                      Bukti pembayaran dalam bentuk struk agar disimpan sebagai
                      bukti pembayaran yang sah dari Bank Mandiri
                    </li>
                    <li>Transaksi Anda telah selesai</li>
                  </ol>
                  <div class="size16 fw-bold-900 ml-1">
                    Melalui Aplikasi Livin' by Mandiri
                  </div>
                  <ol>
                    <li>Silahkan login ke mobile banking Anda.</li>
                    <li>Klik “Icon Menu” di sebelah kiri atas.</li>
                    <li>Pilih menu “Pembayaran”</li>
                    <li>Lanjut buat “Pembayaran Baru”</li>
                    <li>Pilih “Multi Payment”</li>
                    <li>
                      Klik “Penyedia Jasa” atau “Service Provider”, kemudian pilih
                      kode perusahaan, contoh: “Xendit 88908”
                    </li>
                    <li>Pilih “No. Virtual”</li>
                    <li>
                      Masukkan nomor Virtual Account Anda dengan kode perusahaan
                      (contoh 8890802001287578), kemudian pilih “Tambah Sebagai
                      Nomor Baru”
                    </li>
                    <li>Masukkan nominal lalu pilih “Konfirmasi” dan “lanjut”</li>
                    <li>
                      Selanjutnya akan muncul tampilan konfirmasi pembayaran.
                      Pastikan semua informasi dan total tagihan sudah benar. Jika
                      sudah benar, lalu scroll ke bawah dan pilih “Konfirmasi”
                    </li>
                    <li>Masukkan PIN Anda dan pilih “OK”</li>
                    <li>
                      Sampai pada tahap ini, berarti transaksi dengan menggunakan
                      VA telah berhasil dilakukan.
                    </li>
                  </ol>
                </b-collapse>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <!-- Tetap dipakai untuk print; tidak membuat komponen baru -->
    <InvoiceSubscription :detailSubscription="detailSubscription" class="d-none" />
  </div>
</template>

<script>
import { BContainer, BRow, BCol, BImg, BButton, BCollapse, VBToggle } from "bootstrap-vue";
import InvoiceSubscription from "@/components/InvoiceSubscription.vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BImg,
    BButton,
    BCollapse,
    InvoiceSubscription,
  },
  directives: { "b-toggle": VBToggle },
  props: {
    detailSubscription: { type: Object, required: true },
  },
  data() {
    return { copied: false };
  },
  computed: {
    normalizedStatus() {
      return this.detailSubscription?.xendit_provider?.payment_status || null;
    },
    isMandiriVa() {
      return this.detailSubscription?.xendit_provider?.payment_method === "mandiri_va";
    },
    statusMeta() {
      const map = {
        pending: { label: "Menunggu Pembayaran", badge: "bg-warning" },
        success: { label: "Aktif", badge: "bg-primary" },
        canceled: { label: "Dibatalkan", badge: "bg-danger text-white" },
        expired: { label: "Kedaluwarsa", badge: "secondary-2 text-white" },
      };
      return map[this.normalizedStatus] || { label: "-", badge: "badge-light" };
    },
    statusLabel() {
      return this.statusMeta.label;
    },
    statusBadgeClass() {
      return this.statusMeta.badge;
    },
    amountValue() {
      if (this.normalizedStatus === "pending") {
        // uses custom filter formatInvoice
        return this.detailSubscription?.amount != null
          ? this.$options.filters?.formatInvoice
            ? this.$options.filters.formatInvoice(this.detailSubscription.amount)
            : this.detailSubscription.amount
          : null;
      }
      // success/canceled/expired use total | formatAmount
      if (this.detailSubscription?.total != null) {
        return this.$options.filters?.formatAmount
          ? this.$options.filters.formatAmount(this.detailSubscription.total)
          : this.detailSubscription.total;
      }
      return null;
    },
    expireLabel() {
      return this.normalizedStatus === "pending" ? "Bayar Sebelum" : "Berlaku Hingga";
    },
    expireValue() {
      return this.detailSubscription?.payment_expired_at || null;
    },
    showCaraBayar() {
      return this.normalizedStatus === "pending" && this.isMandiriVa;
    },
  },
  methods: {
    async copyToClipboard(text) {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }
        this.copied = true;
        setTimeout(() => (this.copied = false), 1500);
      } catch {
        this.copied = false;
      }
    },
    async print() {
      const { hostname, protocol, port } = window.location;
      const noLandscapeOptions = {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [`${protocol}//${hostname}${port ? `:${port}` : ""}/bootstrap.css`],
        timeout: 1000,
        autoClose: true,
        windowTitle: window.document.title,
      };
      await this.$htmlToPaper("contentPrintSubscription", noLandscapeOptions);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.secondary-2 {
  background-color: $secondary-2;
}
</style>
